import _ from 'lodash';
import { client, clientWithoutErrorHandling } from '../http';

export const OFFERING_TYPES = {
  ONE_OFF: 'oneOff',
  SUBSCRIPTION: 'subscription',
  BUNDLE: 'bundle',
};

async function fetchAccountsToIds() {
  const { data } = await client.get('/api/accounts-to-ids');
  return data;
}

async function getSavedIdNumberForAccount(ibanPiiId, credentialsId) {
  const accountsToIds = await fetchAccountsToIds();
  const matchingRecord = _.find(accountsToIds, item => item.ibanPiiId === ibanPiiId
    && credentialsId === item.credentialsId);
  if (!matchingRecord) {
    return null;
  }
  return matchingRecord.idNumberPiiValue;
}

export default {

  async updateSubscriptionV2({ paymentToken = null, card = null, iterationType }) {
    const response = await clientWithoutErrorHandling.put('/api/v2/subscription', { paymentToken, card, iterationType });
    return response.data;
  },

  async purchaseGiftcard(token, email) {
    const response = await clientWithoutErrorHandling.post('/api/sale', { token, email, productType: 'GIFTCARD' });
    return response.data;
  },
  async purchaseOffering({ token, oneOffOfferings, subscriptionOfferings, bundleOfferings, email }) {
    const response = await client.post(
      '/api/v2/offerings/purchase-new',
      { token, oneOffOfferings, subscriptionOfferings, bundleOfferings, email },
    );
    return response.data;
  },

  async getCreditCardDetails() {
    const response = await clientWithoutErrorHandling.get('/api/credit-card-details');
    return response.data;
  },

  async getSubscriptionV2() {
    const response = await clientWithoutErrorHandling.get('/api/v2/subscription');
    return response.data;
  },

  async getHaveInactivePaymeSubscription() {
    const response = await clientWithoutErrorHandling.get('/api/v2/inactive-subscription');
    return response.data;
  },

  async getSubscription() {
    const response = await clientWithoutErrorHandling.get('/api/subscription');
    return { subscription: response.data };
  },

  async fetchPricingOption() {
    return this.fetchPricingOptionNoAuth();
  },

  async fetchPricingOptionNoAuth() {
    const response = await client.get('/api/no-auth/pricing-options');
    return response.data;
  },

  async getOfferings() {
    const response = await client.get('/api/v2/offerings');
    return response.data;
  },

  async claimVoucher(vendor, worth, price, credentialsId, ibanPiiId, userIdInBank, saveUserIdInBank, vouchersCount) {
    const response = await clientWithoutErrorHandling.post('/api/vouchers/claim', {
      vendor,
      worth,
      price,
      fromCredentialsId: credentialsId,
      fromIbanAccountPiiId: ibanPiiId,
      userIdInBank,
      saveUserIdInBank,
      vouchersCount,
    });
    return response.data;
  },

  async voucherStatusForMember(vendor) {
    const response = await client.get(`/api/vouchers-status/${vendor.toLowerCase()}`);
    return response.data;
  },
  async customerVoucher() {
    const response = await client.get('/api/vouchers');
    return response.data;
  },
  async completeVoucherPurchaseByPaymentRecordId(paymentRecordId, accessCode) {
    const response = await clientWithoutErrorHandling.post('/api/vouchers/complete-purchase', { paymentRecordId, accessCode });
    return response.data;
  },
  async availableVouchers(vendor) {
    const response = await client.get('/api/voucher/available');
    const { vouchers } = response.data;
    return vouchers.filter(item => item.vendor === vendor);
  },

  async  getVouchersStats() {
    const response = await client.get('/api/vouchers-stats');
    return response.data;
  },
  async getFailedPaymentsReasons() {
    const response = await client.get('/api/failed-payment-iterations');
    return response.data;
  },
  async getFailedPaymentOldPrice() {
    const response = await client.get('/api/failed-payment-old-price');
    return response.data;
  },
  getSavedIdNumberForAccount,

  async getProviderUserId({ provider }) {
    const response = await client.get(`/api/provider-user-id/${provider}`);
    return response.data;
  },

  async createSubscription({ provider, data }) {
    const response = await client.post(`/api/v1/subscription/${provider}`, data);
    return response.data;
  },

  async getApplePromotionSignature({ offerId }) {
    const response = await client.get(`/api/v1/apple-promo-signature/${offerId}`);
    return response.data;
  },
};
